import { RefreshCw } from 'lucide-react';

/**
 * RepinPriceButton — Phase C (May 2026).
 *
 * Tiny inline control rendered inside the four calculator-style
 * surfaces (DRIP Calc, What-If, Compare, Portfolio DRIP) that pin
 * prices on open. Clicking it re-fetches / re-pins to the freshest
 * Massive WS price so a user tweaking inputs over a long session
 * doesn't have to close and reopen the modal.
 *
 * Style matches the small "updated Xs ago" pill used elsewhere — a
 * subtle ghost link that doesn't compete with primary CTAs.
 *
 * Props
 *   onClick   — handler that re-pins / re-fetches the surface's data
 *   pinnedAt  — optional ISO string of WHEN the price was last
 *               pinned, used for the title tooltip
 *   busy      — when true, the icon spins and clicks are no-ops
 *   testId    — required; uniqued per surface for E2E selectors
 */
export default function RepinPriceButton({ onClick, pinnedAt, busy = false, testId }) {
  const title = busy
    ? 'Re-pinning prices…'
    : pinnedAt
      ? `Prices pinned ${new Date(pinnedAt).toLocaleTimeString()}. Click to re-pin to current.`
      : 'Re-pin calculator prices to the freshest live values.';
  return (
    <button
      type="button"
      onClick={busy ? undefined : onClick}
      disabled={busy}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold text-muted-foreground hover:text-foreground hover:bg-muted/60 transition-colors disabled:opacity-50"
      title={title}
      data-testid={testId}
    >
      <RefreshCw className={`w-2.5 h-2.5 ${busy ? 'animate-spin' : ''}`} />
      Refresh price{busy ? '…' : ''}
    </button>
  );
}
